import React from 'react';
import { Doughnut } from 'react-chartjs-2';


export function DonutGraph({dataset, datatype}) {

  let value;
  let IncompleteColor = "rgb(128,128,128,0.5)";
  let completeColor = "rgb(227,170,67,0.9)"

switch(datatype) {
  case "physical":
    value = dataset?.physical;
    break;
  case "wellness":
    value = dataset?.wellness
    break;
  case "completed":
    value = dataset
    break;
  default:
}

  var options = {        
    cutoutPercentage: 80
};
  const data = {
    labels: [`Complete`, `Incomplete`],
    datasets: [
      {
        label: '# of Votes',
        data: [value?.completed,(value?.total - value?.completed)],
        backgroundColor: [
          completeColor,
          IncompleteColor,

        ],
        borderColor: [
         completeColor,
          IncompleteColor,
        ],
        borderWidth: 1,
      },
    ],
  };
  return  <Doughnut data={data} width={25} height={7} options={options}/>;
}

